<template>
  <div class="stepnav">
    <ul class="stepnav__list">
      <li
        v-for="i in steps"
        :key="i"
        class="stepnav__item"
        :class="isActive(i - 1)"
      ></li>
    </ul>
    <span :style="{ width: progress + '%' }" class="stepnav__progress"></span>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["step", "steps"],
  computed: {
    progress() {
      return (this.step / (this.steps - 1)) * 100;
    },
  },
  methods: {
    isActive(s) {
      return this.step >= s ? "active" : null;
    },
  },
};
</script>

<style lang="postcss" scoped>
.stepnav {
  position: relative;

  &:before {
    content: "";
    display: block;
    position: absolute;
    height: 0.25em;
    top: 50%;
    margin-top: -0.125em;
    left: 0.5em;
    right: 0.5em;
    background: #ccc;
    z-index: 5;
    transition: width 0.25s ease-out;

    @media (min-width: 40em) {
      margin-top: -0.25em;
      height: 0.5em;
    }
  }
}
.stepnav__progress {
  display: block;
  position: absolute;
  height: 0.25em;
  top: 50%;
  margin-top: -0.25em;
  left: 0;
  background: #e1b143;
  z-index: 20;
  transition: width 0.25s ease-out;

  @media (min-width: 40em) {
    margin-top: -0.25em;
    height: 0.5em;
  }
}

.stepnav__list {
  list-style: none;
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  justify-content: space-between;
}

.stepnav__item {
  text-align: center;
  position: relative;
  z-index: 90;
  border-radius: 50%;
  background: #ccc;
  width: 1em;
  height: 1em;

  @media (min-width: 40em) {
    display: block;
    width: 1.5em;
    height: 1.5em;
  }

  &.active {
    background: #e1b143;
    transition: all 0.5s ease-out;
  }
}

.stepnav__icon {
  padding: 0.25em;
  vertical-align: top;
  border-radius: 50%;
  max-width: 4em;
  padding: 0.75em;
}

.stepnav__title {
  display: block;
  position: absolute;
  font-size: 0.75em;
  left: 50%;
  top: 100%;
  margin-top: 1em;
  transform: translateX(-50%);
}
</style>
